import { DEV } from "utils/urlUtils";

export const COMMUNITY_BASE_URL = DEV
    ? "https://sandboxx-dev.circle.so"
    : "https://community.sandboxx.us";
